const gamesnacks = window.GameSnacks;

export class SDKManager {
    public static local:boolean = false;

    public static gameReady() {
      if(!SDKManager.local){
        gamesnacks.game.ready();
      }
    }

    public static gameOver() {
      if(!SDKManager.local){
        gamesnacks.game.gameOver();

      }

    }

    public static firstFrameReady() {
      if(!SDKManager.local){
        gamesnacks.game.firstFrameReady();

      }

    }

    public static levelComplete(levelNum: number){
      if(!SDKManager.local){
        gamesnacks.game.levelComplete(levelNum);

      }

    }

    public static onGamePause(callback: Function ) {
      if(!SDKManager.local){
        gamesnacks.game.onPause(callback);

      }

    }

    public static onGameResume(callback: Function){
      if(!SDKManager.local){
        gamesnacks.game.onResume(callback);

      }

    }

    public static sendScore(score: number){
      if(!SDKManager.local){
        gamesnacks.score.update(score);

      }
    }

    //ITEMS STORAGE FUNCTIONS
    public static getItem(key: string) {
      if(!SDKManager.local){
        return gamesnacks.storage.getItem(key); //Returns the current value associated with the given key
      }
      // return sys.localStorage.getItem(key);

      }
      public static setItem(key: string, value: string ) {
      if(!SDKManager.local){
        gamesnacks.storage.setItem(key, value) //Sets the value of the pair identified by key to value, creating a new key-value pair if none existed for key previously.

      }
      // sys.localStorage.setItem(key, value)

      }
      public static removeItem(key: string) {
      if(!SDKManager.local){
        gamesnacks.storage.removeItem(key); //Removes the key-value pair with the given key, if a key-value pair with the given key exists

      }

      }
      public static clearStorage() {
      if(!SDKManager.local){
        gamesnacks.storage.clear(); //Removes all key-value pairs, if there are any.

      }

      }

      public static rewardAdCallback(type: string, name: string, beforeAd: Function, afterAd: Function, beforeReward: Function, adDismissed: Function, adViewed: Function, adBreakDone: Function) {
        if(!SDKManager.local){
        gamesnacks.ad.break({ type: type, name: name, beforeAd, afterAd, beforeReward, adDismissed, adViewed, adBreakDone });
      }
    }
    public static interstitialAdCallback(type: string, name: string, beforeAd: Function, afterAd: Function, adBreakDone: Function) {
      if(!SDKManager.local){
        gamesnacks.ad.break({ type: type, name: name, beforeAd, afterAd, adBreakDone });
      }
  }
}